import React, { Component } from "react";
import styles from "./CustomerInfo.module.scss";
import sharedStyles from "../OrderDetailsNewVersion.module.scss";
import Grid from "@material-ui/core/Grid";
import { withTranslation } from "react-i18next";
import crStyles from "../../../customerReservation/crStyles";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import {
  StyledBasicExpansionPanel,
  StyledBasicExpansionPanelSummary,
} from "../../../../shared/ExpansionPanels/ExpansionPanel";
import HasPermissionTo from "../../../../common/HasPermissionTo";
import SharedToolTip from "../../../../shared/sharedToolTip/SharedToolTip";
import { CASH, ORGANIZATION, PERSONAL } from "../../../../common/Constants";
import CustomerInfoDialogEdit from "./CustomerInfoDialogEdit";
import ErrorProcessingDialog from "../../../../errors/ErrorProcessingDialog";
import { CREATED_STATUSES, NULL_OR_UNDEFINED } from "../../../../utils/EmpUtil";

class CustomerInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandCustomerInfo: false,
      customerInfoToolTipOpen: false,
      openEditModal: false,
      openErrorDialog: false,
      cancellationMessage: {},
    };
  }

  expandCustomerInfo() {
    this.setState({ expandCustomerInfo: !this.state.expandCustomerInfo });
  }

  toggleCustomerInfoToolTip = (event) => {
    event.stopPropagation();
    this.setState((prevState) => ({
      customerInfoToolTipOpen: !prevState.customerInfoToolTipOpen,
    }));
  };
  toggleEditModal = () => {
    this.setState((prevState) => ({
      openEditModal: !prevState.openEditModal,
    }));
  };

  openErrorDialog = () => {
    this.setState({
      cancellationMessage: {
        title: this.props.t("Error.processingErrorTitle"),
        body: this.props.t("Error.processingErrorMessage"),
      },
      openErrorDialog: true,
    });
  };

  closeErrorDialog = () => {
    this.setState({
      openErrorDialog: false,
    });
  };

  isCashAndCreatedStatus = (order) =>
    order &&
    !NULL_OR_UNDEFINED(order.status) &&
    CREATED_STATUSES.includes(order.status.toUpperCase()) &&
    order.paymentType === CASH.toUpperCase();

  render() {
    const data = this.props.customerInfoData;
    const isValidConsumerType = data && data.consumerType;

    function getInfoDetails(displayText, displayComma) {
      return (
        displayText && (
          <Grid container>
            <div className={styles.infoDetails}>
              {displayText + (displayComma ? ", " : "")}
            </div>
          </Grid>
        )
      );
    }

    function getHeaderBarTranslation() {
      let translation = "CustomerOrderDetails.customerInformationRetail";
      if (data?.consumerType?.toUpperCase() === ORGANIZATION) {
        translation = "CustomerOrderDetails.customerInformationBusiness";
      } else if (data?.consumerType?.toUpperCase() === PERSONAL) {
        translation = "CustomerOrderDetails.customerInformationRetail";
      }
      return translation;
    }

    function getCustomerTypeTranslation() {
      if (data?.consumerType?.toUpperCase() === PERSONAL) {
        return "CustomerOrderDetails.customerType_Personal";
      } else {
        return "CustomerOrderDetails.customerType_Organization";
      }
    }

    return (
      <StyledBasicExpansionPanel
        defaultExpanded={true}
        onChange={() => this.expandCustomerInfo()}
      >
        <StyledBasicExpansionPanelSummary
          style={crStyles.headerBarNeutral}
          id="exp"
        >
          <div className={sharedStyles.headerBar}>
            <div id="ci" className={sharedStyles.boldHeaderWithToolTip}>
              {this.props.t(getHeaderBarTranslation())}
              <SharedToolTip
                openTestid="customerInfoToolTipOpen"
                open={this.state.customerInfoToolTipOpen}
                closeTooltip={this.toggleCustomerInfoToolTip}
                openTooltip={this.toggleCustomerInfoToolTip}
                body={this.props.t("CustomerOrderDetails.toolTip")}
              />
            </div>
            {this.state.expandCustomerInfo ? (
              <ExpandLessIcon id="less" />
            ) : (
              <ExpandMoreIcon id="more" />
            )}
          </div>
          <br />
        </StyledBasicExpansionPanelSummary>
        <div className={styles.customerInfoGrid}>
          <div className={styles.bottomBorder}></div>

          {data ? (
            <Grid container className={styles.customerContainer}>
              <Grid item xs={2}>
                <Grid container>
                  <Grid item xs={12}>
                    <div className={styles.infoHeader}>
                      {isValidConsumerType &&
                        this.props.t("CustomerOrderDetails.customerType")}
                    </div>
                    {isValidConsumerType && (
                      <div className={styles.infoDetails}>
                        {this.props.t(getCustomerTypeTranslation())}
                      </div>
                    )}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={2}>
                <Grid container>
                  <Grid item xs={12}>
                    <div className={styles.infoHeader}>
                      {data?.consumerType?.toUpperCase() === ORGANIZATION
                        ? this.props.t("CustomerOrderDetails.companyAddress")
                        : this.props.t("CustomerOrderDetails.contactAddress")}
                    </div>
                    {getInfoDetails(data.address1, true)}
                    {getInfoDetails(data.address2, true)}
                    {getInfoDetails(data.address3, true)}
                    {getInfoDetails(data.address4, true)}
                    {(data.city || data.state) && (
                      <div className={styles.infoDetails}>
                        {data.city && data.city}
                        {data.state && ", " + data.state}
                      </div>
                    )}
                    {(data.country || data.zip) && (
                      <div className={styles.infoDetails}>
                        {data.country && data.country}
                        {data.zip && ", " + data.zip}
                      </div>
                    )}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={2}>
                <Grid container>
                  <Grid item xs={12}>
                    <div className={styles.infoHeader}>
                      {this.props.t("CustomerOrderDetails.contactDetails")}
                    </div>
                    {(data.firstName || data.lastName) && (
                      <div className={styles.infoDetails}>
                        {data.firstName && data.firstName}{" "}
                        {data.lastName && data.lastName}
                      </div>
                    )}
                    <div className={styles.infoEmail}>
                      {data.email && data.email}
                    </div>
                    {getInfoDetails(data.phoneNumber, false)}
                    {getInfoDetails(data.mobilePhoneNumber, false)}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={2}>
                {data?.consumerType?.toUpperCase() === ORGANIZATION &&
                  data?.companyName && (
                    <Grid container>
                      <Grid item xs={12}>
                        <div className={styles.infoHeader}>
                          {data?.companyName &&
                            this.props.t("CustomerOrderDetails.companyName")}
                        </div>
                        {data?.companyName && (
                          <div className={styles.infoDetails}>
                            {data.companyName}
                          </div>
                        )}
                      </Grid>
                    </Grid>
                  )}
              </Grid>
              <Grid item xs={2}>
                <HasPermissionTo
                  perform={["inventoryData:view"]}
                  permissions={this.props.user.permissions.rolePermissions}
                  render={() => {
                    return (
                      <Grid container>
                        <Grid item xs={12}>
                          <div className={styles.infoHeader}>
                            {this.props.t("CustomerOrderDetails.scaCID")}
                          </div>
                          {getInfoDetails(data.scacId, false)}
                        </Grid>
                      </Grid>
                    );
                  }}
                />
              </Grid>
              <HasPermissionTo
                perform={["customerInfo:write"]}
                permissions={this.props.user.permissions.rolePermissions}
                condition={this.isCashAndCreatedStatus(
                  this.props.customerReservation
                )}
                render={() => {
                  return (
                    <Grid item xs={2}>
                      <Grid container justifyContent="flex-end">
                        <Grid item xs={12}>
                          <div
                            data-testid="customerInfoEdit"
                            className={styles.infoEdit}
                          >
                            <span
                              data-testid="customerInfoEditText"
                              onClick={this.toggleEditModal}
                            >
                              {this.props.t("customerInfoEditDialog.edit")}
                            </span>
                          </div>
                        </Grid>
                      </Grid>
                    </Grid>
                  );
                }}
              />
              <CustomerInfoDialogEdit
                {...this.props}
                open={this.state.openEditModal}
                closeModal={this.toggleEditModal}
                data={data}
                onError={this.openErrorDialog}
              />
              <ErrorProcessingDialog
                open={this.state.openErrorDialog}
                close={this.closeErrorDialog}
                title={this.state.cancellationMessage.title}
                body={this.state.cancellationMessage.body}
              />
            </Grid>
          ) : (
            <span className={styles.labelError}>
              {" "}
              {this.props.t("CustomerOrderDetails.errorLoadingCustomerInfo")}
            </span>
          )}
        </div>
      </StyledBasicExpansionPanel>
    );
  }
}

export default withTranslation("emp")(CustomerInfo);
